import { logAmplitudeEvent } from 'amplitude/amplitude'
import type { DataProvider, Identifier, Notify } from 'ra-core'

export async function listBulkEditPerformUpdate(
  dataProvider: DataProvider,
  resource: string,
  ids: Identifier[],
  patch: Record<string, unknown>
): Promise<void> {
  await dataProvider.updateMany(resource, { ids, data: patch })
}

export function listBulkEditEmitSaveSuccess(params: {
  resource: string
  recordCount: number
  autoAccept: boolean
  notify: Notify
  translate: (key: string, options?: Record<string, unknown>) => string
  refresh: () => void
  unselectAll: (resource: string) => void
}): void {
  const { resource, recordCount, autoAccept, notify, translate, refresh, unselectAll } = params
  notify(translate('Records updated'), 'success')
  logAmplitudeEvent('list_bulk_edit_modal_saved', {
    resource,
    record_count: recordCount,
    auto_accept: autoAccept,
  })
  refresh()
  unselectAll(resource)
}

export function listBulkEditEmitSaveFailed(params: {
  resource: string
  recordCount: number
  autoAccept: boolean
}): void {
  const { resource, recordCount, autoAccept } = params
  logAmplitudeEvent('list_bulk_edit_modal_save_failed', {
    resource,
    record_count: recordCount,
    auto_accept: autoAccept,
  })
}
